{
  "version": 1,
  "asset_id": "4f39455f-df6d-4ff1-b372-97b1d2082aa2",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/4f39455f-df6d-4ff1-b372-97b1d2082aa2/founder-filippo.webp",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/4f39455f-df6d-4ff1-b372-97b1d2082aa2/founder-filippo.webp",
  "original_filename": "founder-filippo.webp",
  "size": 13274,
  "content_type": "image/webp",
  "created_at": "2026-06-29T16:49:30Z"
}
